import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn('[par-margin] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

export const supabase = url && anonKey
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

// Server-side identity gate. POSTs to /api/check-identity which calls PAR's
// spoke-get-identity with our spoke API key. Returns { allowed, person_id, display_name }.
// Throws on network / server failure — caller should treat as denied with a
// retryable error message.
export async function checkParIdentity(email) {
  const res = await fetch('/api/check-identity', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error || `check-identity failed (${res.status})`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}
